import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../../core/axios/axiosInstance";

const EmailChangeVerification = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [message, setMessage] = useState("Verifying your new email address");
  const [subMessage, setSubMessage] = useState(
    "This should just take a few moments…"
  );
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const verifyEmailChange = async () => {
      try {
        if (token) {
          const response = await api.post("/user/verifyEmailChange", {
            token: token,
          });
          setMessage("Email verified successfully!");
          setSubMessage(
            "Your email address has been updated. You can now close this page."
          );
          setSuccess(true);
          setLoading(false);

          // Optionally redirect after a delay
          setTimeout(() => {
            navigate("/", { replace: true });
          }, 3000);
        } else {
          setMessage("Invalid verification link");
          setSubMessage("No verification token found in the URL.");
          setLoading(false);
        }
      } catch (error) {
        console.error(
          "Email verification failed:",
          error.response?.data || error.message
        );
        setMessage(
          error.response?.data?.message ||
            "Verification failed. The link may be invalid or expired."
        );
        setSubMessage("Please contact your administrator for assistance.");
        setLoading(false);
      }
    };

    verifyEmailChange();
  }, [token, navigate]);

  return (
    <div className="vh-100 d-flex flex-column justify-content-center align-items-center text-center">
      {loading && (
        <div className="spinner-border text-primary mb-4" role="status" />
      )}

      {success && !loading && (
        <div className="mb-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="64"
            fill="#28a745"
            className="bi bi-check-circle-fill"
            viewBox="0 0 16 16"
          >
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
          </svg>
        </div>
      )}

      {!success && !loading && (
        <div className="mb-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="64"
            fill="#dc3545"
            className="bi bi-x-circle-fill"
            viewBox="0 0 16 16"
          >
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
          </svg>
        </div>
      )}

      <h5 className="fw-semibold">{message}</h5>
      {subMessage && <p className="text-muted mb-0">{subMessage}</p>}
    </div>
  );
};

export default EmailChangeVerification;
